import { getCurrentTimeZoneData } from "./timezones";

const pad = (value) => String(value).padStart(2, "0");

const getOffsetMinutes = () => {
  const tzData = getCurrentTimeZoneData();
  const offset = Number(tzData?.offsetMinutes);
  return Number.isFinite(offset) ? offset : 0;
};

export const getPreferredTimeZoneOffsetMinutes = () => getOffsetMinutes();

const formatParts = (
  { year, month, day, hour, minute, second },
  { separator = " ", withSeconds = true } = {}
) => {
  const base = [
    year,
    pad(month),
    pad(day),
  ].join("-") + `${separator}${pad(hour)}:${pad(minute)}`;

  return withSeconds ? `${base}:${pad(second)}` : base;
};

const extractDateParts = (input) => {
  if (!input) return null;

  if (input instanceof Date) {
    return {
      year: input.getFullYear(),
      month: input.getMonth() + 1,
      day: input.getDate(),
      hour: input.getHours(),
      minute: input.getMinutes(),
      second: input.getSeconds(),
    };
  }

  const raw = String(input).trim();
  if (!raw) return null;

  const plainMatch = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/
  );

  if (plainMatch) {
    const [, year, month, day, hour, minute, second = "00"] = plainMatch;
    return {
      year: Number(year),
      month: Number(month),
      day: Number(day),
      hour: Number(hour),
      minute: Number(minute),
      second: Number(second),
    };
  }

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return null;

  return {
    year: parsed.getFullYear(),
    month: parsed.getMonth() + 1,
    day: parsed.getDate(),
    hour: parsed.getHours(),
    minute: parsed.getMinutes(),
    second: parsed.getSeconds(),
  };
};

export const utcToPreferredLocalDateTime = (utcInput, options) => {
  const parts = extractDateParts(utcInput);
  if (!parts) return "";
  return formatParts(parts, options);
};

export const preferredLocalToUTCDateTime = (preferredLocalInput, options) => {
  const parts = extractDateParts(preferredLocalInput);
  if (!parts) return "";
  return formatParts(parts, options);
};
